/* ============================================================
   SKINTEKIE CART — Native Shopify JS
   assets/skintekie-cart.js
   ============================================================ */
(function () {
  'use strict';

  const FREE_SHIPPING_THRESHOLD = 15000;

  const fmt = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);

  function toast(msg, duration) {
    duration = duration || 2500;
    var el = document.querySelector('.sk-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sk-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(el._t);
    el._t = setTimeout(function() { el.classList.remove('show'); }, duration);
  }

  async function cartPost(url, body) {
    const resp = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!resp.ok) throw new Error(resp.statusText);
    return resp.json();
  }

  async function getCart() {
    const resp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return resp.json();
  }

  function updateUI(cart) {
    const subtotal = cart.items_subtotal_price;
    const total = cart.total_price;
    const original = cart.original_total_price;
    const savings = original - total;
    const pct = Math.min((subtotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

    // Shipping bar
    var fill = document.querySelector('[data-shipping-fill]');
    var text = document.querySelector('[data-shipping-text]');
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (subtotal >= FREE_SHIPPING_THRESHOLD) {
        text.textContent = '\u{1F389} You\'ve unlocked FREE shipping & fast 3-day delivery!';
        text.classList.add('unlocked');
      } else {
        var rem = fmt(FREE_SHIPPING_THRESHOLD - subtotal);
        text.textContent = 'Add ' + rem + ' more to unlock FREE shipping \u{1F69A}';
        text.classList.remove('unlocked');
      }
    }

    // Summary
    var summSubtotal = document.querySelector('[data-summary-subtotal]');
    var summShipping = document.querySelector('[data-summary-shipping]');
    var summTotal = document.querySelector('[data-summary-total]');
    var summSavings = document.querySelector('[data-summary-savings]');
    var savingsRow = document.querySelector('[data-savings-row]');

    if (summSubtotal) summSubtotal.textContent = fmt(subtotal);
    if (summShipping) {
      summShipping.textContent = subtotal >= FREE_SHIPPING_THRESHOLD ? 'FREE' : 'Calculated at checkout';
      summShipping.className = subtotal >= FREE_SHIPPING_THRESHOLD
        ? 'sk-summary__val sk-summary__val--free'
        : 'sk-summary__val';
    }
    if (summTotal) summTotal.textContent = fmt(total);
    if (savingsRow && summSavings) {
      if (savings > 0) {
        savingsRow.style.display = 'flex';
        summSavings.textContent = '-' + fmt(savings);
      } else {
        savingsRow.style.display = 'none';
      }
    }

    // Update item count header
    var countEl = document.querySelector('.sk-cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    }
  }

  // Quantity steppers
  function bindQty() {
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() { changeQty(btn, -1); });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() { changeQty(btn, 1); });
    });
    document.querySelectorAll('[data-qty-input]').forEach(function(input) {
      input.addEventListener('change', function() {
        var row = input.closest('[data-line-key]');
        if (!row) return;
        setQty(row.dataset.lineKey, parseInt(input.value) || 1, row);
      });
    });
  }

  async function changeQty(btn, delta) {
    var row = btn.closest('[data-line-key]');
    if (!row) return;
    var input = row.querySelector('[data-qty-input]');
    var current = parseInt(input ? input.value : 1) || 1;
    var newQty = Math.max(1, current + delta);
    if (input) input.value = newQty;
    await setQty(row.dataset.lineKey, newQty, row);
  }

  async function setQty(key, qty, refEl) {
    var left = document.querySelector('[data-cart-left]');
    if (left) left.classList.add('sk-cart-loading');
    try {
      var cart = await cartPost('/cart/change.js', { id: key, quantity: qty });
      updateUI(cart);
      var row = document.querySelector('[data-line-key="' + key + '"]');
      if (row) {
        var item = cart.items.find(function(i) { return i.key === key; });
        if (item) {
          var priceEl = row.querySelector('[data-line-price]');
          if (priceEl) priceEl.textContent = fmt(item.final_line_price);
        } else {
          row.remove();
          if (cart.item_count === 0) setTimeout(function() { window.location.reload(); }, 350);
        }
      }
    } catch(e) {
      toast('Something went wrong. Please refresh.');
    } finally {
      if (left) left.classList.remove('sk-cart-loading');
    }
  }

  // Remove items
  function bindRemove() {
    document.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        var row = btn.closest('[data-line-key]');
        if (!row) return;
        var key = row.dataset.lineKey;
        var left = document.querySelector('[data-cart-left]');
        if (left) left.classList.add('sk-cart-loading');
        try {
          var cart = await cartPost('/cart/change.js', { id: key, quantity: 0 });
          row.style.transition = 'opacity 0.25s, max-height 0.3s';
          row.style.opacity = '0';
          row.style.maxHeight = '0';
          row.style.overflow = 'hidden';
          setTimeout(function() { row.remove(); }, 320);
          updateUI(cart);
          if (cart.item_count === 0) setTimeout(function() { window.location.reload(); }, 500);
        } catch(e) {
          toast('Something went wrong. Please refresh.');
        } finally {
          if (left) left.classList.remove('sk-cart-loading');
        }
      });
    });
  }

  // Order bump
  function bindBump() {
    document.querySelectorAll('[data-bump-add]').forEach(function(btn) {
      btn.addEventListener('click', async function() {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        try {
          await cartPost('/cart/add.js', { items: [{ id: parseInt(variantId), quantity: 1 }] });
          var updatedCart = await getCart();
          updateUI(updatedCart);
          btn.textContent = '\u2713 Added!';
          btn.classList.add('added');
          toast('Added to cart!');
          setTimeout(function() {
            var bump = btn.closest('.sk-bump');
            if (bump) {
              bump.style.transition = 'opacity 0.3s';
              bump.style.opacity = '0';
              setTimeout(function() { bump.remove(); }, 320);
            }
          }, 1200);
        } catch(e) {
          btn.disabled = false;
          btn.textContent = '+ Add';
          toast('Could not add item. Please try again.');
        }
      });
    });
  }

  // Discount toggle
  function bindDiscount() {
    var toggle = document.querySelector('[data-discount-toggle]');
    var form = document.querySelector('[data-discount-form]');
    if (!toggle || !form) return;
    toggle.addEventListener('click', function() {
      form.classList.toggle('open');
      if (form.classList.contains('open')) {
        var inp = form.querySelector('input');
        if (inp) inp.focus();
      }
    });
  }

  async function init() {
    try {
      var cart = await getCart();
      updateUI(cart);
    } catch(e) { console.warn('[SKCart] init error:', e); }
    bindQty();
    bindRemove();
    bindBump();
    bindDiscount();
  }

  document.addEventListener('DOMContentLoaded', init);
})();